export class InvoiceDownload {
  accountNumber: string = '';
  workOrderNumber: string = '';
}
